<div class="main">
  <div *ngIf="data?.type === 'success'"></div>
  <div class="error-container" *ngIf="data?.type === 'error'">
    <mat-icon [matTooltip]="toolTip" color="warn">error</mat-icon>
  </div>
  <p
    class="text"
    [matTooltip]="data?.text?.length > data?.maxCaracter ? data.text : ''"
    [matTooltipClass]="{ bydAlertTooltip: true }"
  >
    {{ data?.text | truncate : data?.maxCaracter }}
  </p>
  <mat-icon *ngIf="data.secondActionIcon" class="close-icon" (click)="secondAction.emit()">{{
    data.secondActionIcon
  }}</mat-icon>
  <mat-icon *ngIf="!data.disableClose" class="close-icon" (click)="onClose()">cancel</mat-icon>
</div>
